import { useLexicalSyncStateModel } from './lexical-sync-state.model'
import type { ILexicalSyncState } from './lexical-sync-state.types'

export const LexicalSyncState = (props: ILexicalSyncState) => {
  useLexicalSyncStateModel(props)
  return null
}
